import React, { Component } from "react"
import PropTypes from "prop-types"
import { RequireAuthenticated } from "../auth"
import { AppHeader } from "../common"

/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/
export default class App extends Component {
  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: "",
  }

  render() {
    return (
      <div className="home-app">
        <RequireAuthenticated>
          <AppHeader />
          {this.props.children}
        </RequireAuthenticated>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/home/App.js